import { createFileRoute } from '@tanstack/react-router'
import { JobScoring } from '@/features/job-detail/scoring'

export const Route = createFileRoute('/_authenticated/jobs/$jobId/scoring')({
  component: JobScoring,
})
